import React, { useContext, useState, useEffect } from 'react';

const CurrentUserContext = React.createContext()
const CurrentUserUpdateContext = React.createContext()

const useCurrentUser = () => {return useContext(CurrentUserContext)}
const useSetCurrentUser = () => {return useContext(CurrentUserUpdateContext)}

const CurrentUserProvider = ({ children }) => {
  const [currentUser, setCurrentUser] = useState({token:'',username:'', lessons: []});
  const user = localStorage.getItem('codingsummit_user');
  useEffect(()=>{
    if (user){setCurrentUser(JSON.parse(user))}
    return () => {
      if (user){
        localStorage.setItem('codingsummit_user', JSON.stringify(user));
      }
    }
  },[]);

  return (
    <CurrentUserContext.Provider value={currentUser}>
      <CurrentUserUpdateContext.Provider value={setCurrentUser}>
        { children }
      </CurrentUserUpdateContext.Provider>
    </CurrentUserContext.Provider>
  )
};

export { useCurrentUser, useSetCurrentUser };
export default CurrentUserProvider;